import { Flex, Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import React from 'react';
import { IconType } from 'react-icons/lib';

import { CopyButton } from '../../CopyButton';

interface Props {
  LeftIcon: IconType;
  text?: string;
  fallback?: string;
}

export const ClientContactRow = ({ LeftIcon, text, fallback }: Props) => {
  if (!text && !fallback) return null;

  const displayValue = text || fallback || '';
  const showFallback = !text && fallback;

  return (
    <Flex mb={2} width="100%">
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <LeftIcon size="20px" />
        </InputLeftElement>
        <Input
          backgroundColor="bg.default"
          className="amp-mask excluded-phi"
          readOnly
          value={displayValue}
          fontSize="12px"
          color={showFallback ? 'text.muted' : 'text.default'}
          mr={2}
          borderColor="border.default"
        />
      </InputGroup>

      <CopyButton
        textToCopy={text || ''}
        variant="outline"
        disabled={!text}
        ml={0}
        size="md"
        backgroundColor="bg.default"
        borderColor="border.default"
        tooltipProps={{
          closeDelay: 0,
          placement: 'right',
        }}
      />
    </Flex>
  );
};
